import React, { useEffect, useState } from 'react'
import { useCurrentTheme } from 'src/editor/layout/sidebar/website-styles-settings/hooks/useCurrentTheme'
import { WebsiteThemeInterface } from 'src/shared/types/website-settings-types'
import { WebsiteThemeDropdown } from '../website-theme-dropdown'
import { dropdownGroupTitlesLocoKeys } from '../website-theme-dropdown/consts'
import { WebsiteDropdownGroupTitles } from '../website-theme-dropdown/types'
import { pickThemeGroups } from './utils'

export const WebsiteThemeDropdownGroupSection = () => {
  const [groups, setGroups] = useState<null | Omit<
    WebsiteThemeInterface,
    'id' | 'isCommon' | 'name'
  >>()

  const { currentTheme, onUpdate } = useCurrentTheme()

  const handleUpdate = (
    groupKey: keyof WebsiteThemeInterface,
    key: string,
    value: string | number | null,
  ) => {
    onUpdate({
      [groupKey]: {
        ...(currentTheme[groupKey] as object),
        [key]: value,
      },
    })
  }

  useEffect(() => {
    if (currentTheme) {
      setGroups(pickThemeGroups(currentTheme))
    }
  }, [currentTheme])

  return (
    <section className="mt-9 flex flex-col gap-4">
      {groups &&
        Object.entries(groups).map(group => (
          <WebsiteThemeDropdown
            key={group[0]}
            data={group[1]}
            onUpdate={(key, value) => {
              handleUpdate(group[0] as keyof WebsiteThemeInterface, key, value)
            }}
            title={
              dropdownGroupTitlesLocoKeys[
                group[0] as WebsiteDropdownGroupTitles
              ]
            }
          />
        ))}
    </section>
  )
}
